import {
  getTranscriberProgramConfig,
  TRANSCRIBER_PROGRAM_CODE,
} from "lookup/TranscriberProgramConstants.jsx";

const DEFAULT_PAGE_SIZE = 15;

export const resolveTranscriberProgramCode = (location) => {
  const params = new URLSearchParams(location.search);
  const programCodeFromQuery = params.get("programCode");

  if (programCodeFromQuery && getTranscriberProgramConfig(programCodeFromQuery)) {
    return programCodeFromQuery;
  }

  if (location.pathname.endsWith("/dmr/list")) {
    return TRANSCRIBER_PROGRAM_CODE.DMR;
  }

  return TRANSCRIBER_PROGRAM_CODE.STD;
};

export const createDefaultListState = (programCode) => {
  const programConfig = getTranscriberProgramConfig(programCode);

  return {
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    sorted: programConfig.defaultSorting,
    filtered: programConfig.defaultFilter,
    resized: [],
    expanded: {},
  };
};

export const createInitialProgramState = (programCode) => ({
  data: [],
  pages: 0,
  totalElements: "Loading ...",
  loading: false,
  isError: false,
  listState: createDefaultListState(programCode),
  indexOnList: null,
});
